module.exports = __webpack_public_path__ + "img/Spinner-1s-240px.a10adac2.svg";